



















import {Component, Prop, Vue} from 'vue-property-decorator';
import ZCLogo from '../assets/logo.svg';
import VueQrcode from 'vue-qrcode';
// @ is an alias to /src

@Component({
	components: {
		ZCLogo,
		'qr-code': VueQrcode
	}
})
export default class QRCodeOverlay extends Vue {
	@Prop({default: ''})
	payUrl!: string;

	get width() {
		return Math.max(500, window.innerWidth - 80);
	}
	close() {
		this.$emit('close');
	}
}
